type IconName =
  | 'alert-circle'
  | 'arrow-left'
  | 'arrow-right'
  | 'bell'
  | 'building'
  | 'car'
  | 'calendar'
  | 'check'
  | 'check-circle'
  | 'chevron-right'
  | 'credit-card'
  | 'copy'
  | 'door-open'
  | 'edit'
  | 'eye'
  | 'file'
  | 'file-text'
  | 'grid'
  | 'home'
  | 'key'
  | 'layout'
  | 'list'
  | 'mail'
  | 'message-square'
  | 'phone'
  | 'plus'
  | 'refresh-ccw'
  | 'search'
  | 'shield-check'
  | 'sparkles'
  | 'star'
  | 'store'
  | 'trash'
  | 'trend-up'
  | 'user'
  | 'users'
  | 'repeat'
  | 'x';

type BrandIconName = 'google' | 'microsoft';
type FlagIconName = 'nl' | 'fr' | 'en' | 'de';

interface IconOptions {
  size?: number;
  width?: number;
  height?: number;
  className?: string;
  strokeWidth?: number;
  attrs?: string;
}

const ICON_PATHS: Record<IconName, string> = {
  'alert-circle': '<circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>',
  'arrow-left': '<line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>',
  'arrow-right': '<line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>',
  bell: '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>',
  building: '<rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 7h.01"/><path d="M12 7h.01"/><path d="M16 7h.01"/><path d="M8 11h.01"/><path d="M12 11h.01"/><path d="M16 11h.01"/><path d="M10 21v-4h4v4"/>',
  car: '<path d="M5 17h14l-1.5-5h-11z"/><path d="M5 17v2"/><path d="M19 17v2"/><circle cx="7.5" cy="17.5" r="1.5"/><circle cx="16.5" cy="17.5" r="1.5"/><path d="M7 12l2-4h6l2 4"/>',
  calendar: '<rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>',
  check: '<polyline points="20 6 9 17 4 12"/>',
  'check-circle': '<circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/>',
  'chevron-right': '<polyline points="9 18 15 12 9 6"/>',
  'credit-card': '<rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/>',
  copy: '<rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>',
  'door-open': '<path d="M14 3H6a2 2 0 0 0-2 2v14"/><path d="M14 3h1a2 2 0 0 1 2 2v14"/><path d="M14 22H6"/><path d="M14 12h.01"/><path d="M19 13h2"/>',
  edit: '<path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>',
  eye: '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>',
  file: '<path d="M14 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7z"/><path d="M14 2v5h5"/>',
  'file-text': '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>',
  grid: '<rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/>',
  home: '<path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V21h14V9.5"/>',
  key: '<circle cx="7.5" cy="15.5" r="4.5"/><path d="M12 15.5h9"/><path d="M18 12.5v6"/><path d="M21 12.5v3"/>',
  layout: '<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 10h18"/><path d="M9 10v10"/>',
  list: '<line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>',
  mail: '<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22 6 12 13 2 6"/>',
  'message-square': '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>',
  phone: '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.45 2 2 0 0 1 3.6 1h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 8.91a16 16 0 0 0 6 6l.81-.81a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>',
  plus: '<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>',
  'refresh-ccw': '<polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/>',
  repeat: '<polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>',
  search: '<circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>',
  'shield-check': '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/>',
  sparkles: '<path d="M12 3l1.9 4.6L18.5 9.5l-4.6 1.9L12 16l-1.9-4.6L5.5 9.5l4.6-1.9L12 3z"/><path d="M19 14l.9 2.1L22 17l-2.1.9L19 20l-.9-2.1L16 17l2.1-.9L19 14z"/><path d="M5 14l.9 2.1L8 17l-2.1.9L5 20l-.9-2.1L2 17l2.1-.9L5 14z"/>',
  star: '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>',
  store: '<path d="M3 9l1-5h16l1 5"/><path d="M4 9h16v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"/><path d="M9 21v-6h6v6"/>',
  trash: '<polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>',
  'trend-up': '<polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/>',
  user: '<path d="M20 21a8 8 0 0 0-16 0"/><circle cx="12" cy="8" r="4"/>',
  users: '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
  x: '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>',
};

const BRAND_SVGS: Record<BrandIconName, { viewBox: string; content: string }> = {
  google: {
    viewBox: '0 0 48 48',
    content: '<path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59A14.5 14.5 0 0 1 9.5 24c0-1.59.28-3.14.76-4.59l-7.98-6.19A23.99 23.99 0 0 0 0 24c0 3.77.87 7.35 2.56 10.56l7.97-5.97z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 5.97C6.51 42.62 14.62 48 24 48z"/>',
  },
  microsoft: {
    viewBox: '0 0 21 21',
    content: '<rect x="1" y="1" width="9" height="9" fill="#f25022"/><rect x="11" y="1" width="9" height="9" fill="#7fba00"/><rect x="1" y="11" width="9" height="9" fill="#00a4ef"/><rect x="11" y="11" width="9" height="9" fill="#ffb900"/>',
  },
};

const FLAG_SVGS: Record<FlagIconName, { viewBox: string; content: string }> = {
  nl: {
    viewBox: '0 0 16 12',
    content: '<rect width="16" height="4" fill="#ae1c28"></rect><rect y="4" width="16" height="4" fill="#ffffff"></rect><rect y="8" width="16" height="4" fill="#21468b"></rect>',
  },
  fr: {
    viewBox: '0 0 16 12',
    content: '<rect width="5.33" height="12" fill="#0055a4"></rect><rect x="5.33" width="5.34" height="12" fill="#ffffff"></rect><rect x="10.67" width="5.33" height="12" fill="#ef4135"></rect>',
  },
  de: {
    viewBox: '0 0 16 12',
    content: '<rect width="16" height="4" fill="#000000"></rect><rect y="4" width="16" height="4" fill="#dd0000"></rect><rect y="8" width="16" height="4" fill="#ffce00"></rect>',
  },
  en: {
    viewBox: '0 0 16 12',
    content: '<rect width="16" height="12" fill="#012169"></rect><path d="M0 0 L6.2 4.45 L5.15 4.45 L0 0.8 Z" fill="#ffffff"></path><path d="M16 0 L9.8 4.45 L10.85 4.45 L16 0.8 Z" fill="#ffffff"></path><path d="M0 12 L6.2 7.55 L5.15 7.55 L0 11.2 Z" fill="#ffffff"></path><path d="M16 12 L9.8 7.55 L10.85 7.55 L16 11.2 Z" fill="#ffffff"></path><path d="M0 0.4 L5.5 4.3 L4.55 4.3 L0 1.1 Z" fill="#c8102e"></path><path d="M16 0.4 L10.5 4.3 L11.45 4.3 L16 1.1 Z" fill="#c8102e"></path><path d="M0 11.6 L5.5 7.7 L4.55 7.7 L0 10.9 Z" fill="#c8102e"></path><path d="M16 11.6 L10.5 7.7 L11.45 7.7 L16 10.9 Z" fill="#c8102e"></path><rect x="6.3" width="3.4" height="12" fill="#ffffff"></rect><rect y="4.3" width="16" height="3.4" fill="#ffffff"></rect><rect x="6.9" width="2.2" height="12" fill="#c8102e"></rect><rect y="4.9" width="16" height="2.2" fill="#c8102e"></rect>',
  },
};

function svgTag(content: string, options: IconOptions & { viewBox?: string; fill?: string; stroke?: string }): string {
  const {
    size = 16,
    width = size,
    height = size,
    className,
    strokeWidth = 2,
    attrs = '',
    viewBox = '0 0 24 24',
    fill = 'none',
    stroke = 'currentColor',
  } = options;

  return `<svg${className ? ` class="${className}"` : ''} width="${width}" height="${height}" viewBox="${viewBox}" fill="${fill}"${stroke ? ` stroke="${stroke}" stroke-width="${strokeWidth}"` : ''}${attrs ? ` ${attrs}` : ''}>${content}</svg>`;
}

export function icon(name: IconName, options: IconOptions = {}): string {
  return svgTag(ICON_PATHS[name], options);
}

export function brandIcon(name: BrandIconName, options: IconOptions = {}): string {
  const brand = BRAND_SVGS[name];
  return svgTag(brand.content, {
    ...options,
    viewBox: brand.viewBox,
    fill: 'none',
    stroke: '',
  });
}

export function flagIcon(name: FlagIconName, options: IconOptions = {}): string {
  const flag = FLAG_SVGS[name];
  return svgTag(flag.content, {
    ...options,
    viewBox: flag.viewBox,
    fill: 'none',
    stroke: '',
  });
}

export function propertyTypeIcon(type: string, options: IconOptions = {}): string {
  const name =
    type === 'Appartement' ? 'building' :
    type === 'Huis' ? 'home' :
    type === 'Studio' ? 'layout' :
    type === 'Commercieel' ? 'store' :
    type === 'Garage' ? 'car' :
    'building';

  return icon(name, options);
}
